import React from 'react';
import PropTypes from 'prop-types';
import { getDocumentSectionData } from './configStructure.js';
import './DocumentSection.scss';

const DocumentSection = (props) => {
    const documentData = getDocumentSectionData();
    function getDocumentDataList(list) {
        let value;
        return <table>
            <tbody>
                {Array.isArray(props.fieldValues) && props.fieldValues.map((fieldValue, index) => {
                    if (fieldValue.docId === undefined) {
                        return (
                            <div className="no-id">
                                <span className="no-id">Your document is unavailable at this time.</span>
                                <span className="no-id">Please try again later.</span>
                            </div>
                        );
                    }
                    switch (list.displayType) {
                        case "DOCUMENT":
                            const imageTitle = fieldValue[list.columnKey];
                            const titleStart = imageTitle ? imageTitle.slice(0, 10) : '';
                            const titleFinish = imageTitle ? imageTitle.slice(-10) : '';
                            const displayTitle = imageTitle && imageTitle.length < 25 ? imageTitle :`${titleStart}...${titleFinish}`;
                            value = <a onClick={() => props.openModal(props.documents, fieldValue[list.columnKey], fieldValue["docId"])}>{displayTitle}</a>;
                            break;
                        default:
                            value = fieldValue[list.columnKey];
                            break;
                    }
                    return <tr key={index}>
                        <td>{value === undefined ? "--" : value}</td>
                    </tr>
                })}
            </tbody>
        </table>
    }
    return <div className="document-section-card" >

        <span className="section-title">{props.title}</span>
        {props.fieldValues !== undefined && <span className="section-view" key={documentData.dataColumns?.columnKey}>
            {documentData.dataColumns?.map((list, index) => {


                return <span className="list-view" key={index}>
                    <span className="list-title">{list.name}</span>
                    <span className="list-value">{getDocumentDataList(list)}</span>
                </span>


            })}
        </span>}

    </div>

};

DocumentSection.propTypes = {
    fieldValues: PropTypes.array,
    title: PropTypes.string,
    openModal: PropTypes.func,
    documents: PropTypes.array,
};

DocumentSection.defaultProps = {
};

export default (DocumentSection);
